<template>
    <div class="page-header pt-8 sm:pt-12 lg:pt-16">
        <h1 class="heading-1 text-center lg:w-4/5 xl:w-3/5 lg:mx-auto">{{ title }}</h1>
        <div v-if="subtitle" class="text-center mt-2 text-sm sm:text-base lg:w-3/5 lg:mx-auto" v-html="subtitle"></div>
    </div>
</template>

<script>
export default {
    name: 'PageHeader',
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style>
.theme-dark .page-header h1 {
    @apply text-white;
}
.page-header div {
    @apply text-grey-500;
}
.theme-dark .page-header div {
    @apply text-grey-325;
}
</style>
